import React from "react";
import { NAV_BAR_BLOCK_HEIGHT } from "utils/constants/ui";

const NavBarTopBlock = () => (
  <div style={{ height: NAV_BAR_BLOCK_HEIGHT }} className="dib h-100 w-100" />
);

export default NavBarTopBlock;
